import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { LoaderComponent } from './loader/loader.component';
import { MatDialogModule } from '@angular/material/dialog';
import { MatMenuModule } from '@angular/material/menu';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { RouterModule } from '@angular/router';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatPaginatorModule } from '@angular/material/paginator';
import { PaginationComponent } from './pagination/pagination.component';
import { ConfirmationPopUpComponent } from './confirmation-pop-up/confirmation-pop-up.component';
import { MatChipsModule } from '@angular/material/chips';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatSelectModule } from '@angular/material/select';
import { MatTabsModule } from '@angular/material/tabs';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatStepperModule } from '@angular/material/stepper';
import { DaysAgoOrLeftPipe } from '../config/days-ago-or-left';
import { MailTimePipe } from '../config/mail-time';
import {MatRadioModule} from '@angular/material/radio';
import { TranslateModule } from '@ngx-translate/core';
import { TooltipDirective } from './tooltip/tooltip.directive';
import { ScrollingModule } from '@angular/cdk/scrolling';
import { SvgIconComponent } from './svg-icon/svg-icon.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { FilesPreviewerComponent } from './files-previewer/files-previewer.component';
import { DocumentHighlightLayerComponent } from './files-previewer/document-highlight-layer/document-highlight-layer.component';
import { DocumentHotspotLayerComponent } from './files-previewer/document-hotspot-layer/document-hotspot-layer.component';
import { PdfViewerModule } from 'ng2-pdf-viewer';
import { TitleCasePipe } from '../config/title-case-pipe';
import { FilesDialogPreviewerComponent } from './files-dialog-previewer/files-dialog-previewer.component';
import { AgentCompaniesListComponent } from '../features/agents/components/agent-details/agent-portfolio/agent-companies-list/agent-companies-list.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ChartComponent } from './chart/chart.component';
import { GiftTooltipComponent } from './components/gift-tooltip/gift-tooltip.component';
import { GiftBannerComponent } from './components/gift-banner/gift-banner.component';
import { AdaptToUserUtcOffsetPipe } from '../core/pipes/adapt-to-user-utc-offset';
import { DiscountTooltipComponent } from './components/discount-tooltip/discount-tooltip.component';
import { ObjectCustomFieldsViewComponent } from './components/object-custom-fields-view/object-custom-fields-view.component';
import { PriceDetailsTooltipComponent } from '../features/quotations/components/price-details-tooltip/price-details-tooltip.component';
import { PriceCandidatesPanelComponent } from '../features/quotations/components/price-candidates-panel/price-candidates-panel.component';
import { QtyDetailsTooltipComponent } from '../features/quotations/components/qty-details-tooltip/qty-details-tooltip.component';
import { HasPermissionDirective } from './has-permission.directive';
import { FtueAnchorDirective } from './ftue-anchor.directive';
import { HasFieldVisibilityDirective } from './has-field-visibility.directive';
import { ProductCodePipe } from '../core/pipes/product-code.pipe';

@NgModule({
  declarations: [
    LoaderComponent,
    PaginationComponent,
    ConfirmationPopUpComponent,
    DaysAgoOrLeftPipe,
    MailTimePipe,
    TitleCasePipe,
    AdaptToUserUtcOffsetPipe,
    SvgIconComponent,
    FilesPreviewerComponent,
    DocumentHighlightLayerComponent,
    DocumentHotspotLayerComponent,
    FilesDialogPreviewerComponent,
    AgentCompaniesListComponent,
    ChartComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatSnackBarModule,
    MatProgressBarModule,
    MatDialogModule,
    MatMenuModule,
    MatSlideToggleModule,
    CKEditorModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    MatChipsModule,
    MatExpansionModule,
    MatSelectModule,
    MatTabsModule,
    DragDropModule,
    MatCheckboxModule,
    MatRadioModule,
    MatStepperModule,
    TranslateModule,
    ScrollingModule,
    MatDatepickerModule,
    PdfViewerModule,
    GiftTooltipComponent,
    GiftBannerComponent,
    TooltipDirective,
    DiscountTooltipComponent,
    ObjectCustomFieldsViewComponent,
    PriceDetailsTooltipComponent,
    PriceCandidatesPanelComponent,
    QtyDetailsTooltipComponent,
    HasPermissionDirective,
    HasFieldVisibilityDirective,
    FtueAnchorDirective,
    ProductCodePipe
  ],
  exports: [
    CommonModule,
    RouterModule,
    MatTableModule,
    MatIconModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule,
    MatProgressBarModule,
    LoaderComponent,
    MatDialogModule,
    MatMenuModule,
    MatSlideToggleModule,
    CKEditorModule,
    MatFormFieldModule,
    MatAutocompleteModule,
    MatPaginatorModule,
    PaginationComponent,
    AgentCompaniesListComponent,
    MatChipsModule,
    MatExpansionModule,
    MatSelectModule,
    MatTabsModule,
    DragDropModule,
    MatCheckboxModule,
    MatRadioModule,
    MatStepperModule,
    DaysAgoOrLeftPipe,
    MailTimePipe,
    TitleCasePipe,
    TranslateModule,
    TooltipDirective,
    AdaptToUserUtcOffsetPipe,
    ScrollingModule,
    SvgIconComponent,
    MatDatepickerModule,
    FilesPreviewerComponent,
    MatTooltipModule,
    ChartComponent,
    GiftTooltipComponent,
    GiftBannerComponent,
    DiscountTooltipComponent,
    ObjectCustomFieldsViewComponent,
    PriceDetailsTooltipComponent,
    PriceCandidatesPanelComponent,
    QtyDetailsTooltipComponent,
    HasPermissionDirective,
    HasFieldVisibilityDirective,
    FtueAnchorDirective,
    ProductCodePipe
  ]
})
export class SharedModule { }
